/** @license ISC License (c) copyright 2017 original and current authors */
/** @author Ian Hofmann-Hicks (evil) */

var getProp = require('./getProp')

module.exports =
  getProp.origFn('prop')
